// 嘉银交互比较复杂，一些弹窗状态需要全局管理
export default {
  state: {
    cancelOrRefundShow: false,
    showCancelRenewalModal: false,
    h5Data: {},
  },
  getters: {

  },
  mutations: {
    setCancelOrRefundShow(state, payload) {
      state.cancelOrRefundShow = payload;
    },
    setH5Data(state, payload) {
      state.h5Data = payload;
    },
    setShowCancelRenewalModal(state, payload) {
      state.showCancelRenewalModal = payload;
    },
  }
}